import React, { useState } from "react";
import useAuth from "../../hooks/useAuth";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

export default function Login() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { createUserWithEmail } = useAuth();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await createUserWithEmail(email, password);
      window.location.reload();
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <div className="container no-scroll mx-auto">
      <div className="flex flex-col justify-center items-center h-full">
        <div className="scroll">
          <div>
            <img
              className="w-full h-40 object-contain"
              src={require("../../assets/images/layout/login.png")}
              alt="logo"
            />

            <div className="mt-5 mb-10">
              <h2 className="text-3xl font-semibold text-center">
                {t("nomeJogo1")}
              </h2>
            </div>
          </div>
          <div className="pl-5 pr-5">
            <input
              type="email"
              placeholder={t("email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-4 !bg-[#434343] text-white rounded-xl mb-5"
            />
            <input
              type="password"
              placeholder={t("password")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-4 !bg-[#434343] text-white rounded-xl"
            />
            <div className="ms-5 me-5 mt-5">
              <button
                onClick={handleRegister}
                className="btn btn-small btn-brand w-full pt-3 pb-3 text-2xl leading-7"
              >
                {t("loginRegister")}
              </button>
            </div>
            <div className="text-center mt-5">
              <Link className="font-medium" to="/">
                {t("loginAlreadyHas")}
                <span className="text-[#DF5260]"> {t("enterNow")}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
